import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Search from "components/Search";
import SleekSearch from "components/Sleek/SleekSearch";

interface FilterSearchProps {
  onSearch: (value: string) => void;
  searchPeriod?: number;
  placeholder?: string;
  suggestions?: any[];
  onSuggestionClick?: (suggestion: any) => void;
  className?: string;
  // Seeds the input on mount — used to keep two instances of the same search in sync.
  defaultValue?: string;
}

// Every page toolbar's search, in the Trends pages' finish at the toolbar's size (2026-10-26: `SleekSearch`, small): a
// rounded field, its × and its search button. Width is caller-controlled via className (e.g. max-w-[35%]). A search
// offering suggestions (the trend filter bar's) keeps the suggesting `Search`, at the same height and radius.
const FilterSearch = ({ onSearch, searchPeriod, placeholder, suggestions, onSuggestionClick, className, defaultValue }: FilterSearchProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue ?? "");
  // the old search's own default, so no toolbar's search is a blank field
  const said = placeholder ?? (t("common:search.placeholder_default") as string);
  if (suggestions)
    return (
      <Search
        onSearch={onSearch}
        searchPeriod={searchPeriod}
        placeholder={placeholder}
        suggestions={suggestions}
        onSuggestionClick={onSuggestionClick}
        defaultValue={defaultValue}
        className={clsx("w-full [&_.input-container]:!h-9 [&_.input-container]:!py-0 [&_.input-container]:!rounded-full", className)}
      />
    );

  return (
    <SleekSearch
      size="sm"
      value={value}
      wait={searchPeriod ?? 600}
      ariaLabel={said}
      placeholder={said}
      className={clsx("w-full", className)}
      onSearch={(text) => {
        setValue(text);
        onSearch(text);
      }}
    />
  );
};

export default FilterSearch;
